export default __webpack_public_path__ + "static/media/deck_customize.d92adb14.webp";